<template>
    <div name="description-of-soldoc3" class="description-of-soldoc3">
        <div class="description-of-soldoc3-inner">
            <h3>더 많은 환자를<br>더 효율적으로</h3> 
            <div class="section-container1">
                <p class="subject">진료 외 기타 프로세스를 혁신적으로 간소화하여<br>효율적인 대면/비대면 진료가 가능합니다</p>
                <div class="gif-area">
                    <p>기존 시간 당 진료 가능 인원</p>
                    <img class="mouse-arrow" src="../../assets/partners_mobile/img_description_of_soldoc6.gif" alt="">
                    <p><strong>솔닥파트너스</strong>를 통한 진료 가능 인원<br><strong class="primary">단위 시간당 진료 인원 평균 90% 상승</strong></p>
                </div>
            </div>
            <div class="section-container2">
				<div class="accordion-list">
					<div class="accordion-item" v-for="(item, index) in accordionItems" :key="index">
						<button type="button" class="title" @click="open(index)">
							<span class="num">0{{ index + 1 }}</span><strong class="tit">{{ item.title }}<br>{{ item.title2 }}</strong>
						</button>
						<transition name="accordion">
							<div class="content" v-show="selected === index">
								<div class="inner">
									<p>{{ item.content1 }}<br>{{ item.content2 }}<br>{{ item.content3 }}</p>
								</div>
							</div>
						</transition>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "description-of-soldoc3",
    data: function() {
        return {
            selected: 0,
			accordionItems: [
				{ title: '솔닥 어드민에서 바로 차팅하세요', content1: '솔닥으로 접수된 진료는 기존 차트에 옮기지 않고', content2: '쉽고 직관적인 솔닥 어드민에서 바로 차팅할 수', content3: '있습니다.', isOpen: false },
				{ title: '모바일 예진지 미리 전달하세요', content1: '환자와의 소통이 한결 수월해지는 예진지로', content2: '불필요하게 낭비되는 진료 시간을 단축하세요.', isOpen: false },
				{ title: '각종 진료 서류, 클릭 한 번으로', title2: '발급하세요', content1: '직접 작성하고 출력해서 스캔할 필요 없이', content2: '클릭 한 번으로 간편하게 환자 앱으로 전송하세요.', isOpen: false },
			],
		};
    },
    computed: {},
    mounted: function() {        
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".description-of-soldoc3-inner").offset().top;
            var aniTit = $(".description-of-soldoc3-inner h3");
            var aniCon1 = $(".description-of-soldoc3-inner .section-container1");
            var aniCon2 = $(".description-of-soldoc3-inner .section-container2");
            
            if (height <= 0) {
                $(aniTit).removeClass('item-show').addClass('item-hide');
                $(aniCon1).removeClass('item-show').addClass('item-hide');
                $(aniCon2).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1000) {
                $(aniTit).removeClass('item-hide').addClass('item-show');
                $(aniCon1).removeClass('item-hide').addClass('item-show');
                $(aniCon2).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1500) {
                $(aniTit).removeClass('item-show').addClass('item-hide');
                $(aniCon1).removeClass('item-show').addClass('item-hide');
                $(aniCon2).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {
        open(index) {
            this.selected = this.selected === index ? null : index;
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        },
    },
};
</script>

<style scoped>
.description-of-soldoc3 {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    max-height: 1360px;
    background: #FFF;
    overflow: hidden;
}
.description-of-soldoc3-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding: 71px 5px 100px;
}
.description-of-soldoc3-inner h3 {
    min-height: 84px;
    margin-bottom: 0;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    line-height: 42px;
    color: #000;
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc3-inner .section-container1 {
    max-width: 346px;
    width: 100%;
    margin-top: 55px;
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc3 .section-container1 .item {
    position: relative;
    width: 100%;
}
.description-of-soldoc3 .section-container1 .item + .item {
    margin-top: 68px;
}
.description-of-soldoc3 .section-container1 .item:first-child {
    height: 432px;
}
.description-of-soldoc3 .section-container1 .item:last-child {
    height: 459px;
}
.description-of-soldoc3 .section-container1 img {
    width: 100%;
}
.description-of-soldoc3 .section-container1 .flex-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 41px 0 24px;
}
.description-of-soldoc3 .section-container1 .item h4 {
    margin-bottom: 0;
    font-size: 26px;
    font-weight: 600;
    line-height: 32px;
    color: #1A1A1A;
}
.description-of-soldoc3 .section-container1 .item strong {
    display: block;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px; 
    color: #1A1A1A;
}
.description-of-soldoc3 .section-container1 .item p {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px; 
    color: #666;
    letter-spacing: -0.1px;
}
.description-of-soldoc3 .section-container1 .item .label-area {
    display: flex;
    align-items: center;
    height: 28px;
}
.description-of-soldoc3 .section-container1 .item .label-area span {
    width: 88px;
    height: 100%;
    padding: 0 13px;
    border-radius: 100px;
    background: #008DEF;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
    color: #FFF;
}
.description-of-soldoc3 .section-container1 .item .label-area span + span {
    width: 76px;
    margin-left: 6px;
}
.description-of-soldoc3-inner .section-container2 {
    max-width: 346px;
    width: 100%;
    visibility: hidden;
    opacity: 0;
}
.description-of-soldoc3-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}.description-of-soldoc3-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.description-of-soldoc3 .section-container2 .box-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
}
.description-of-soldoc3 .section-container2 .box-content > div {
    position: relative;
    width: 100%;
    height: 546px;
    padding: 38px 25px 0;
    border-radius: 20px;
}
.description-of-soldoc3 .section-container2 .box-content > div:first-child {
    background: #EBF7FE; 
}
.description-of-soldoc3 .section-container2 .box-content > div:nth-child(2) {
    background: #008DEF;
}
.description-of-soldoc3 .section-container2 .box-content > div:last-child {
    background: #F4F6F9;
}
.description-of-soldoc3 .section-container2 .box-content > div:first-child .img-area {
    width: 338px;
    height: auto;
    margin: 71px 50% 0;
    overflow: hidden;
    transform: translateX(-44.5%);
}
.description-of-soldoc3 .section-container2 .box-content > div:nth-child(2) .img-area {
    position: absolute;
    bottom: 50px;
    right: 26px;
    width: 207px;
    height: auto;
}
.description-of-soldoc3 .section-container2 .box-content > div:last-child .img-area {
    position: absolute;
    bottom: 61px;
    right: 40px;
    width: 174px;
    height: auto;
}
.description-of-soldoc3 .section-container2 .img-area img {
    width: 100%;
}
.description-of-soldoc3 .section-container2 .box-content > div span {
    display: block;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    color: #008DEF;
}
.description-of-soldoc3 .section-container2 .box-content > div strong {
    font-size: 24px;
    font-weight: 600;
    line-height: 34px;
    color: #1A1A1A;
}
.description-of-soldoc3 .section-container2 .box-content > div p {
    margin-top: 16px;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #1A1A1A;
}
.description-of-soldoc3 .section-container2 .box-content > div:nth-child(2) * {
    color: #fff;
}
.description-of-soldoc3 .section-container2 .box-content > div:nth-child(2) span {
    color: #EBF7FE;
}

.description-of-soldoc3 .section-container1 {
    width: 100%;
    max-width: 346px;
    margin-top: 28px;
    margin-bottom: 140px;
}
.description-of-soldoc3 .section-container1 .subject {
    margin-bottom: 55px;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #1A1A1A;
    text-align: center;
}
.description-of-soldoc3 .section-container1 .gif-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.description-of-soldoc3 .section-container1 .gif-area p:first-child {
    position: relative;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #999;
}
.description-of-soldoc3 .section-container1 .gif-area p:first-child::before {
    content: '';
    position: absolute;
    bottom: -76px;
    left: calc(50% - 173px);
    width: 346px;
    height: 63px;
    border-radius: 100px;
    background: #F6F6F6;
}
.description-of-soldoc3 .section-container1 .gif-area p:first-child::after {
    content: '';
    position: absolute;
    bottom: -68.5px;
    left: -48px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #D9D9D9;
    box-shadow: 120px 0 0 0 #D9D9D9, 240px 0 0 0 #D9D9D9;
}
.description-of-soldoc3 .section-container1 .gif-area img {
    width: 346px;
    height: 63px;
    margin-top: 94px;
}
.description-of-soldoc3 .section-container1 .gif-area p:last-child {
    margin-top: 18px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #1A1A1A;
    text-align: center;
}
.description-of-soldoc3 .section-container1 .gif-area p:last-child strong {
    font-weight: 600;
}
.description-of-soldoc3 .section-container1 .gif-area p:last-child strong.primary {
    font-weight: 700;
    color: #008DEF;
}
.description-of-soldoc3 .section-container2 {
    width: 100%;
    max-width: 346px;
}
.description-of-soldoc3 .section-container2 .accordion-list {
    border-top: 2px solid #008DEF;
    border-bottom: 2px solid #D9D9D9    
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item {
    margin: 0;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item + .accordion-item {
	border-top: 1px solid #D9D9D9;
}
.description-of-soldoc3 .section-container2 .accordion-list .title {
    position: relative;
	width: 100%;
    height: 81px;
    padding: 24px 0 ;
    cursor: pointer;
	border: 0;
	background-color: transparent;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:last-child .title {
    height: 108px;
}
.description-of-soldoc3 .section-container2 .accordion-list .title .num {
    position: absolute;
    top: 24px;
    left: 0;
    font-size: 20px;
    font-weight: 600;
    color: #008DEF;
    line-height: 30px;
}
.description-of-soldoc3 .section-container2 .accordion-list .title .tit {
    position: absolute;
    top: 24px;
    left: 41px;
    font-size: 20px;
    font-weight: 600;
    color: #000;
    line-height: 30px;
    text-align: left;
}
.description-of-soldoc3 .section-container2 .accordion-list .content .inner {
	height: 317px;
	padding: 0 0 0 41px;
}
.description-of-soldoc3 .section-container2 .accordion-list .content .inner p {
	margin-bottom: 0;
	font-size: 16px;
	font-weight: 400;
	line-height: 26px;
	color: #1A1A1A;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item .inner {
	position: relative;
	margin-top: -6px;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:first-child .inner::before {
	content: '';
	position: absolute;
	right: 0;
    bottom: 0;
	width: 306px;
	height: 196px;
    background: url(../../assets/partners_mobile/img_description_of_soldoc7.png) 0 0 no-repeat;
    background-size: 306px auto;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:nth-child(2) .inner::before {
	content: '';
	position: absolute;
	right: 0;
    bottom: 0;
	width: 180px;
    height: 231px;
    background: url(../../assets/partners_mobile/img_description_of_soldoc8.png) 0 0 no-repeat;
    background-size: 180px auto;
}
.description-of-soldoc3 .section-container2 .accordion-list .accordion-item:last-child .inner::before {
	content: '';
	position: absolute;
	right: 0;
    bottom: 0;
	width: 181px;
	height: 231px;
    background: url(../../assets/partners_mobile/img_description_of_soldoc9.png) 0 0 no-repeat;
    background-size: 181px auto;
}
.accordion-enter-active, .accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.8s ease, opacity 0.8s ease;
    overflow: hidden;
}
.accordion-enter, .accordion-leave-to {
    height: 0 !important;
    opacity: 0;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}

@media screen and (max-width: 359px) {
    .description-of-soldoc3 .d-up-sm {
        display: none;
    }
    .description-of-soldoc3 {
        height: auto;
    }
    .description-of-soldoc3-inner {
        padding: 100px 20px;
    }
    .description-of-soldoc3 .description-of-soldoc3-inner h3 {
        min-height: auto;
        font-size: 28px;
        line-height: 40px;
    }
    .description-of-soldoc3 .section-container1 .item h4 {
        font-size: 24px;
        line-height: 30px;
    }
    .description-of-soldoc3 .section-container1 .item strong {
        font-size: 18px;
        line-height: 30px;
    }
    .description-of-soldoc3 .section-container1 .item p {
        font-size: 14px;
        line-height: 24px;
    }
    .description-of-soldoc3 .section-container2 {
        margin-top: 90px;
        margin-bottom: 85px;
    }
    .description-of-soldoc3 .section-container2 .box-content > div {
        height: 522px;
    }
    .description-of-soldoc3 .section-container2 .box-content > div:first-child .img-area {
        width: 270.4px;
    }
    .description-of-soldoc3 .section-container2 .box-content > div:nth-child(2) .img-area {
        width: 165.6px;
    }
    .description-of-soldoc3 .section-container2 .box-content > div:last-child .img-area {
        width: 139.2px;
    }
    .description-of-soldoc3 .section-container2 .box-content > div strong {
        font-size: 22px;
        line-height: 32px;
    }
    .description-of-soldoc3 .section-container2 .box-content > div p {
        font-size: 14px;
        line-height: 24px;
    }
    .description-of-soldoc3 .section-container1 .subject {
        font-size: 14px;
        line-height: 24px;
    }
    .description-of-soldoc3 .section-container2 .accordion-list .title .num {
        font-size: 18px;
        line-height: 28px;
    }
    .description-of-soldoc3 .section-container2 .accordion-list .title .tit {
        font-size: 18px;
        line-height: 28px;
    }
    .description-of-soldoc3 .section-container2 .accordion-list .content .inner p {
        font-size: 14px;
        line-height: 24px;
    }
    .description-of-soldoc3 .section-container2 .accordion-list .accordion-item:first-child .inner::before {
        content: '';
        position: absolute;
        right: 0;
        bottom: -1px;
        width: 275.4px;
        height: 176.4px;
        background: url(../../assets/partners_mobile/img_description_of_soldoc7.png) 0 0 no-repeat;
        background-size: 275.4px auto;
    }
    .description-of-soldoc3 .section-container2 .accordion-list .accordion-item:nth-child(2) .inner::before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 162px;
        height: 207.9px;
        background: url(../../assets/partners_mobile/img_description_of_soldoc8.png) 0 0 no-repeat;
        background-size: 162px auto;
    }
    .description-of-soldoc3 .section-container2 .accordion-list .accordion-item:last-child .inner::before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 162.9px;
        height: 207.9px;
        background: url(../../assets/partners_mobile/img_description_of_soldoc9.png) 0 0 no-repeat;
        background-size: 162.9px auto;
    }
}
@media screen and (max-width: 369px) {
    .description-of-soldoc3 .section-container1 .gif-area p:first-child::before {
        bottom: -76px;
        left: calc(50% - 155.7px);
        width: 311.4px;
        height: 56.7px;
    }
    .description-of-soldoc3 .section-container1 .gif-area p:first-child::after {
        bottom: -68.5px;
        left: -43.2px;
        width: 43.2px;
        height: 43.2px;
        box-shadow: 108px 0 0 0 #D9D9D9, 216px 0 0 0 #D9D9D9;
    }
    .description-of-soldoc3 .section-container1 .gif-area img {
        width: 311.4px;
        height: 56.7px;
        margin-top: 94px;
    }
}
@media screen and (max-width: 410px) {
    .description-of-soldoc3 .d-up-md {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/DescriptionOfSoldoc3.vue